import React from 'react';
import styled, { css } from 'styled-components';
import JustificationContainer, {
  Props as JustificationContainerProps,
} from '../../../JustificationContainer';

export type Props = JustificationContainerProps;

const NotificationBubble: React.FC<Props> = ({ children, ...rest }) => (
  <Bubble
    justification="center"
    align="center"
    backgroundColor={{ group: 'secondary', variant: 'base' }}
    border={{
      radius: 'full',
    }}
    padding={['s']}
    height="24px"
    {...rest}
  >
    {children}
  </Bubble>
);

const Bubble = styled(JustificationContainer)(
  ({ theme }) => css`
    color: ${theme.color('secondary', 'text')};
    font-size: ${theme.fs('s')};
    font-weight: 600;
    min-width: 24px;
  `,
);

export default NotificationBubble;
